import { createActionType } from '../core';
import { NAME } from './constants';

export const SIGN_IN = createActionType(`${NAME}/SIGN_IN`);
export const REFRESH_TOKEN = createActionType(`${NAME}/REFRESH_TOKEN`);
export const SIGN_OUT = `${NAME}/SIGN_OUT`;